import { Serialiser } from "hooks/serialisers/types";
import { Setter } from "./state/syncing";
import { useQueryParamState } from "./useQueryParamState";
import { useMemo } from "react";

export const useStringQueryParamState = <T extends string | null>(
  paramName: string,
  defaultValue: T
): [T, Setter<T>] => {
  const stringSerialiser: Serialiser<T, unknown> = useMemo(
    () => ({
      format: (value) => value ?? "",
      parse: (text) => ({ valid: true, value: text as T }),
    }),
    []
  );
  const [value, setValue] = useQueryParamState(
    paramName,
    stringSerialiser,
    defaultValue
  );
  return [value, setValue];
};
